import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout } from 'antd'
import { withTranslation } from 'react-i18next'
import { IsSearchMenu } from '../../utils/read-querystring-helper'

import HeaderPage from '../../components/Guest/Header/headerMain'
import ChatPage from '../Chat/chatPage'
import FooterMenu from '../../components/Guest/Footer/Footer'

const { Content } = Layout;

@inject("translationStore", "loginStore", "authStore")
@observer
class MasterChatPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login')
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });
    }

    render() {
        const history = this.props.history
        const isSearchMenu = IsSearchMenu(this)

        return (
            <Layout className='stm-layout-master'>
                <Content>
                    {!isSearchMenu ? (<HeaderPage history={history} />) : <React.Fragment></React.Fragment>}

                    <ChatPage history={history} />

                    {!isSearchMenu ? (<FooterMenu history={history} menuText={'chat'} />) : <React.Fragment></React.Fragment>}
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(MasterChatPage)